import { render, staticRenderFns } from "./FormQualification.vue?vue&type=template&id=bf4fe9a4&"
import script from "./FormQualification.vue?vue&type=script&lang=js&"
export * from "./FormQualification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports